import { render, staticRenderFns } from "./my-tree.vue?vue&type=template&id=65ade38e&scoped=true&"
import script from "./my-tree.vue?vue&type=script&lang=js&"
export * from "./my-tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ade38e",
  null
  
)

export default component.exports